<div class="sticky-header">
  <app-top-bar title="CART.TITLE"></app-top-bar>
  <app-combo-guide-block></app-combo-guide-block>
</div>

@if (lines().length > 0) {
  <div class="clear-cart" (click)="clearCart()">
    <span>{{ 'CART.CLEAR' | translate }}</span>
  </div>
}

<div class="page">
  @if (lines().length === 0) {
    <div class="empty-page" data-testid="cart-empty">
      {{ 'CART.EMPTY' | translate }}
    </div>
  } @else {
    <div>
      @for (line of lines(); track line.id) {
        <app-cart-line-item
          class="border-line"
          [line]="line"
          (increase)="increaseQty(line)"
          (decrease)="decreaseQty(line)"
          (editClick)="editLine(line)">
        </app-cart-line-item>
      }
    </div>

    @if (!isReadOnly()) {
      <app-recommendations />
    }

    <div class="order-info" [class.border-line]="hasOrderInfo()">
      @if (!isReadOnly()) {
        <div class="order-note-wrap">
          <div class="order-note" data-testid="cart-order-note" (click)="addComment()">
            <img class="icon-md" [src]="'order-note.svg' | themeSource">
            <span>
              @if (orderNote()) {
                {{ orderNote() }}
              } @else {
                {{ 'ORDER.NOTES' | translate }}
              }
            </span>
          </div>
        </div>
      }

      @if (orderMessage()) {
        <p>{{ orderMessage() }}</p>
      }

      @if (showMinOrderMessage()) {
        <p class="min-order" translate [translateParams]="{'currency': currency(), 'amount': checkout.minOrder() - subtotal()}">
          COMMON.ADD_MIN_ORDER
        </p>
      }
    </div>

    @if (!isReadOnly()) {
      @if (isPrepaid()) {
        <app-voucher-form (voucherApplied)="checkout.onVoucherApplied($event)" [(hideVoucher)]="checkout.hideVoucher" [(voucher)]="checkout.voucherInput" />
        <app-tipping-form [total]="subtotal()" [selection]="checkout.tipSelection()" (tipApplied)="checkout.onTipApplied($event)" />

        <div class="order-summary">
          @if (checkout.fees().length > 0 || checkout.appliedVoucher()?.amount || checkout.appliedPromo()?.amount) {
            <div>
              <span>{{ 'ORDER.SUBTOTAL' | translate }}</span>
              <span>{{ subtotal() | currencySpace }}</span>
            </div>
          }

          <!-- An automatic promotion: no code was entered, so this line is the
               only thing telling the guest the offer applied. -->
          @if (checkout.appliedPromo(); as promo) {
            @if (promo.amount) {
              <div>
                <span>{{ 'PAY_AT_TABLE.PROMO' | translate }}</span>
                <span>- {{ promo.amount | currencySpace }}</span>
              </div>
            }
          }

          @if (checkout.appliedVoucher(); as voucherInfo) {
            @if (voucherInfo.amount) {
              @if (voucherInfo.mode === VoucherMode.Balance) {
                <div>
                  <span>{{ 'VOUCHER.CURRENT_BALANCE' | translate }}</span>
                  <span>{{ voucherInfo.amount | currencySpace }}</span>
                </div>
              } @else {
                <div>
                  <span>{{ 'PAY_AT_TABLE.DISCOUNT' | translate }}</span>
                  <span>- {{ voucherInfo.amount | currencySpace }}</span>
                </div>
              }

              @if (voucherInfo.mode === VoucherMode.Balance) {
                @if (checkout.isOrderFree()) {
                  <div>
                    <span>{{ 'VOUCHER.REMAINING_BALANCE' | translate }}</span>
                    <span>{{ voucherInfo.amount - subtotal() | currencySpace }}</span>
                  </div>
                } @else {
                  <div>
                    <span>{{ 'VOUCHER.AMOUNT_DUE' | translate }}</span>
                    <span>{{ checkout.totalWithTip() | currencySpace }}</span>
                  </div>
                }
              }
            }
          }

          @for (fee of checkout.fees(); track fee.id) {
            @if (fee.amount) {
              <div>
                <span>{{ fee.name }}</span>
                <span>{{ fee.amount | currencySpace }}</span>
              </div>
            }
          }

          @if (checkout.tipAmount()) {
            <div>
              <span>{{ 'TIP.TIP' | translate }}</span>
              <span>{{ checkout.tipAmount() | currencySpace }}</span>
            </div>
          }

          <div>
            <span>{{ 'CART.TOTAL' | translate }}</span>
            <span>{{ checkout.totalWithTip() | currencySpace }}</span>
          </div>
        </div>

        @if (checkout.isOrderFree()) {
          <button class="btn" type="button" (click)="submit()" [disabled]="checkout.submitted()">
            {{ 'CART.PLACE_ORDER' | translate }}
          </button>
        } @else {
          <app-payment-options-sheet
            [paymentMethods]="checkout.paymentTypes()"
            [disabled]="checkout.isLoading() || checkout.submitted()"
            (optionSelected)="onPrepaidPaymentSelected($event)">
          </app-payment-options-sheet>
        }
      } @else {
        @if (!isPayNowOnly()) {
          <button class="btn" type="button" data-testid="cart-submit-button" (click)="submit()" [disabled]="checkout.submitted()">
            {{ (isPayAtTable() ? 'CART.ADD_TO_BILL' : 'CART.PLACE_ORDER') | translate }}
          </button>
        }

        @if (isPayAtTable() && isPayNowEnabled()) {
          <button class="btn" type="button" data-testid="cart-checkout-button" (click)="displayCheckout()" [disabled]="checkout.submitted()">
            {{ (isPayNowOnly() ? 'CART.PLACE_ORDER' : 'CART.PAY_NOW') | translate }}
          </button>
        }
      }
    }
  }
</div>

<app-loader-overlay [active]="checkout.isLoading()" />